module.exports = __webpack_public_path__ + "img/freight_yard1_3.759b6ef3.png";